import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";

import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";

export const HhMeterComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();

  if (hidden) return null;
  return (
    <div className="sales-doc-field mb-3">
      <div className="sales-doc-label-row">
        <span id={`meter-${meter.id.toString()}-hh-label`} className="sales-doc-group-label">
          HH Meter?
        </span>
        <OverlayTrigger overlay={<Tooltip>Meter with a 00 profile</Tooltip>} placement="right">
          <QuestionCircle style={{ cursor: "help" }} />
        </OverlayTrigger>
      </div>
      <div
        className="sales-doc-radios form-check"
        role="radiogroup"
        aria-labelledby={`meter-${meter.id.toString()}-hh-label`}
      >
        <label htmlFor={`meter-${meter.id.toString()}-hh-yes`}>
          <input
            className="form-check-input"
            type="radio"
            id={`meter-${meter.id.toString()}-hh-yes`}
            name={`meter-${meter.id.toString()}-hh`}
            value="yes"
            checked={ctx.hhMeter === "yes"}
            onChange={() => {
              ctx.setHhMeter("yes");
            }}
          />
          Yes
        </label>
        <label htmlFor={`meter-${meter.id.toString()}-hh-no`}>
          <input
            type="radio"
            id={`meter-${meter.id.toString()}-hh-no`}
            className="form-check-input"
            name={`meter-${meter.id.toString()}-hh`}
            value="no"
            checked={ctx.hhMeter === "no"}
            onChange={() => {
              ctx.setHhMeter("no");
            }}
          />
          No
        </label>
      </div>
    </div>
  );
};
